var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: { id: "client-card-modal", "ok-only": "", "ok-title": "Закрыть" }
    },
    [
      _c("template", { slot: "modal-title" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("icon", { staticClass: "mr-3", attrs: { name: "user" } }),
            _vm._v(" "),
            _c("span", [_vm._v("Информация о клиенте")])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.client
        ? [
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("b", [_vm._v("Бренд:")]),
              _c("span", [_vm._v(_vm._s(_vm.client.brand.name))])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("b", [_vm._v("Имя клиента:")]),
              _c("span", [_vm._v(_vm._s(_vm.client.name))])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("b", [_vm._v("Номер телефона:")]),
              _c("span", [_vm._v(_vm._s(_vm.client.phone))])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex justify-content-between" }, [
              _c("b", [_vm._v("Скидка клиента:")]),
              _c("span", [_vm._v(_vm._s(_vm.client.discount))])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between" },
              [
                _c("b", { staticClass: "mt-1" }, [_vm._v("Комментарий:")]),
                _c("b-input", {
                  staticClass: "ml-4",
                  model: {
                    value: _vm.clientComment,
                    callback: function($$v) {
                      _vm.clientComment =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "clientComment"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex justify-content-between mt-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 mr-1",
                    attrs: {
                      disabled: !_vm.commentWasChanged,
                      variant: "danger",
                      size: "sm"
                    },
                    on: {
                      click: function($event) {
                        return _vm.resetComment()
                      }
                    }
                  },
                  [_vm._v("Отменить")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "w-100 ml-1",
                    attrs: {
                      disabled: !_vm.commentWasChanged,
                      variant: "success",
                      size: "sm"
                    },
                    on: { click: _vm.updateComment }
                  },
                  [_vm._v("Сохранить")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.client.lastAddresses
              ? [
                  _c("h5", [_vm._v("Последние адреса:")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.client.lastAddresses.nodes.length === 0
                        ? _c("div", [
                            _vm._v(
                              "\n          Адресов для доставки не найдено\n        "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.client.lastAddresses.nodes, function(
                        address,
                        ind
                      ) {
                        return _c(
                          "div",
                          {
                            key: ind,
                            staticClass: "address",
                            on: {
                              click: function($event) {
                                return _vm.setOrderAddress(address)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.formatAddress(address)) +
                                "\n        "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f038a04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f038a04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ClientCard.vue
// module id = null
// module chunks = 